import React, { useState, createContext, useContext } from 'react';
const UpsellContext = createContext<{
  open: () => void;
  close: () => void;
  isOpen: boolean;
}>({
  open: () => {},
  close: () => {},
  isOpen: false
});
export const useUpsell = () => useContext(UpsellContext);
export const UpsellProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <UpsellContext.Provider value={{
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false)
  }} data-id="element-230">
      {children}
    </UpsellContext.Provider>;
};